import React, { Fragment } from 'react';
import styled from 'styled-components';
import { FieldConfiguration } from '../../api/ConfigApi';
import { AuthData } from '../../context/auth';
import { PolicyData, withPolicyContext } from '../../context/policy';
import {
	FieldGroupCreateRequest,
	FieldGroupsByLocatorMap,
	FieldValuesMap,
} from '../../types/policy';
import { StyledWrappedFields } from '../common';
import FieldReviewChanges from './fields/FieldReviewChanges';
import { isFieldAvailableForDisplay } from './fields/util';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
	currentFieldValues: FieldValuesMap; // current field values are the pending changes that the user is making
	fieldConfigurations: FieldConfiguration[];
	fieldGroupsByLocator: FieldGroupsByLocatorMap;
	fieldValues: FieldValuesMap; // fieldValues is the values from the server
	pendingFieldValues?: FieldValuesMap;
	addFieldGroups?: FieldGroupCreateRequest[]; // for endorsements
	groupIndex?: string; // for group field unique keys
}

// for review changes endorsement
const FieldEditorFormReadOnly = (props: Props) => {
	const {
		currentFieldValues,
		fieldConfigurations,
		fieldGroupsByLocator,
		fieldValues,
		addFieldGroups,
		groupIndex,
	} = props;

	if (!currentFieldValues) {
		return null;
	}

	if (!fieldConfigurations.length) {
		return null;
	}

	const renderField = (field: any, index: number) => {
		if (
			isFieldAvailableForDisplay(
				fieldConfigurations,
				{ ...fieldValues, ...currentFieldValues },
				field.name,
			)
		) {
			// if (currentFieldValues[field.name] !==)
			let value: any = currentFieldValues[field.name] || '';

			if (!value && fieldValues[field.name]) {
				// if no updated value then look for original value
				if (field.type === 'group') {
					// Require whole value array when group type

					value = fieldValues[field.name];
				} else {
					value = fieldValues[field.name][0];
				}
			}

			const width = field.type === 'group' ? '12' : field.width || '6';

			return (
				<FieldContainer className={`width-${width}`}>
					<FieldReviewChanges
						value={value}
						field={field}
						fieldGroupsByLocator={fieldGroupsByLocator}
						allValues={{ ...fieldValues, ...currentFieldValues }}
						currentFieldValues={currentFieldValues}
						groupIndex={groupIndex}
						addFieldGroups={addFieldGroups}
					/>
				</FieldContainer>
			);
			// {/* {field.type === 'group' && <Break />} */}
		} else {
			return null;
		}
	};
	// Fieldeditorform > Field > [string, group] > Fieldeditorform
	const content = fieldConfigurations.map((field: any, index: number) => {
		function getRandomInt(max: any) {
			return Math.floor(Math.random() * Math.floor(max));
		}
		// const key = `${field.name}-${groupIndex}`;
		const key1 = `${field.name}-${groupIndex}-${getRandomInt(99999)}`;

		return (
			<Fragment key={key1}>
				{field.newline || (field.type === 'group' && <Break />)}
				{renderField(field, index)}
				{field.type === 'group' && <Break />}
			</Fragment>
		);
	});

	return <StyledWrappedFields>{content}</StyledWrappedFields>;
};

const Break = styled.div`
	width: 100%;
	height: 0;
`;

const FieldContainer = styled.div`
	padding-top: 10px;
	padding-right: 10px;
	box-sizing: border-box;

	&.width-12 {
		width: 100%;
	}
	&.width-11 {
		width: 91.66%;
	}
	&.width-10 {
		width: 83.33%;
	}
	&.width-9 {
		width: 75%;
	}
	&.width-8 {
		width: 66.66%;
	}
	&.width-7 {
		width: 58.33%;
	}
	&.width-6 {
		width: 50%;
	}
	&.width-5 {
		width: 41.66%;
	}
	&.width-4 {
		width: 33.33%;
	}
	&.width-3 {
		width: 25%;
	}
	&.width-2 {
		width: 16.66%;
	}
`;

export default withPolicyContext<Props>(FieldEditorFormReadOnly);
